import { JBaseApi } from '../base';
import { ApiWrapper } from '../../types';
import { OF } from '../../util/network';
import { JIACapabilities, TextEnhanceResponse } from '../../types/jia';

export class JIAApi extends JBaseApi {
    public textEnhancement({
        text,
        capacity,
    }: {
        text?: string;
        capacity?: JIACapabilities;
    }): Promise<ApiWrapper<TextEnhanceResponse>> {
        return this.network.post({
            o: 'jia',
            f: 'textEnhancement',
            text,
            capacity,
        } as OF);
    }
}
